import i18next from 'i18next'
export const isStringContainsAllowedLinksQuantity =
  ({ message, allowedLinksQuantity = 1 }) =>
  (value: any) => {
    // eslint-disable-next-line no-useless-escape
    const anchorTagsRegEx = /<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g
    if (value && value.match(anchorTagsRegEx)?.length > allowedLinksQuantity) {
      return {
        isValid: false,
        message: i18next.t(message),
      }
    }
  }
